<script setup>
import { useRouter } from 'vue-router';
import { useModoManutencao } from '@/composables/useModoManutencao';

const router = useRouter();
const { avisoManutencaoVisivel, fecharAvisoManutencao } = useModoManutencao();

function aoFechar() {
    fecharAvisoManutencao();
    router.replace('/login');
}
</script>

<template>
    <Dialog :visible="avisoManutencaoVisivel" modal :draggable="false" :style="{ width: '28rem' }"
        :breakpoints="{ '640px': '92vw' }" @update:visible="(valor) => !valor && aoFechar()">
        <template #container>
            <div class="flex flex-column align-items-center text-center p-5 surface-overlay border-round-3xl">
                <div class="w-4rem h-4rem border-circle bg-blue-50 flex align-items-center justify-content-center mb-4">
                    <i class="pi pi-wrench text-blue-600 text-2xl" />
                </div>

                <p class="m-0 font-bold text-xl text-900">Sistema em manutenção</p>
                <p class="mt-2 mb-0 text-sm text-600 line-height-3">
                    Estamos realizando uma manutenção no sistema e voltaremos a funcionar em breve.
                    Agradecemos pela compreensão.
                </p>

                <Button label="Entendi" size="small" class="text-sm mt-5 w-full" @click="aoFechar" />
            </div>
        </template>
    </Dialog>
</template>
